export default __webpack_public_path__ + "static/media/img-guide-gt-popup-3-fr_fr@2x.27317fbd.png";